import { Box, Popover, Tag, Text, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  ErrorTypes,
  ValidationError,
  formatBreakTime,
} from 'modules/attendance/lib/validateShiftBreakDurationRules'

interface ShiftInconsistencyProps {
  restTimeInconsistencies: ValidationError[]
  numberOfBreakMinimumErrors: number
  numberOfRestTimeErrors: number
}

const ShiftsInconsistenciesAlert = ({
  restTimeInconsistencies,
  numberOfBreakMinimumErrors,
  numberOfRestTimeErrors,
}: ShiftInconsistencyProps) => {
  const alertContent = numberOfBreakMinimumErrors + numberOfRestTimeErrors
  const [open, toggle] = useToggle()
  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
    >
      <Box>
        <Tag leftItem="icon" icon="alert-circle" inline showCircle size="normal" type="radical">
          {alertContent}
        </Tag>
      </Box>
      {restTimeInconsistencies.map((error, index) => {
        const title =
          error.error === ErrorTypes.REST_TIME
            ? i18n.t('time_tracking.modals.rest_time_alerts.min_rest_time_title')
            : i18n.t('time_tracking.modals.rest_time_alerts.minimum_break_title', {
                amount: numberOfBreakMinimumErrors > 1 ? `(${numberOfBreakMinimumErrors})` : '',
              })

        const description =
          error.error === ErrorTypes.REST_TIME
            ? i18n.t('time_tracking.modals.rest_time_alerts.min_rest_time_description_short', {
                break_duration: error.minimalDuration,
                hours_worked: formatBreakTime(error.periodLength ?? 0),
              })
            : i18n.t('time_tracking.modals.rest_time_alerts.min_break_description_short', {
                minutes: error.minimalDuration,
              })

        return (
          <Box key={index} textAlign="left">
            <Box paddingBottom="s2">
              <Text.Normal size="300" color="white" weight="bold">
                {title}
              </Text.Normal>
            </Box>
            <Box paddingBottom="s2">
              <Text.Normal size="300" color="white" weight="medium">
                {description}
              </Text.Normal>
            </Box>
          </Box>
        )
      })}
    </Popover.ItemList>
  )
}

export default ShiftsInconsistenciesAlert
